<div
  #modalbackground
  class="background"
  (click)="closeFromBackground($event)"
></div>
<div class="window">
  <div class="wrapper">
    <div class="header-row">
      <div class="arrow">
        <img
          id="{{ startingFocusIndex + 1 }}"
          src="assets/arrow-left-lightgrey.svg"
          (click)="shiftMonthUp(false)"
          (keydown)="onKeyAction($event, false)"
          tabindex="-1"
        />
      </div>
      <div class="month">
        {{ formatMonthYear(monthDisplayed.name, monthDisplayed.date.getFullYear()) }}
      </div>
      <div class="arrow right">
        <img
          id="{{ startingFocusIndex + 2 }}"
          src="assets/arrow-right-lightgrey.svg"
          (click)="shiftMonthUp(true)"
          (keydown)="onKeyAction($event, true)"
          tabindex="-1"
        />
      </div>
    </div>
    <div class="weekday-row">
      <div *ngFor="let dn of dayNames" class="weekday">
        {{ dn | translate }}
      </div>
    </div>
    <div class="days-grid">
      <div
        *ngFor="let day of daysDisplayed; index as i"
        id="{{ i + startingFocusIndex + 3 }}"
        class="calendar-day"
        [class.selected]="isDateInArray(selectedDates, day)"
        [class.today]="day.getTime() === currentDate.getTime()"
        (click)="onSelectDate(day, $event)"
        (keydown)="onKeyAction($event, day)"
        tabindex="-1"
      >
        {{ day.getDate() | translate }}
      </div>
    </div>
    <div class="clear" (click)="onClearSelection()">Clear Selection</div>
  </div>
</div>
